import {
  CARDSTAR_OVERRIDE_ACCOUNT_CREATION,
  FISERV_SIGNIN_PROD_URL,
  FISERV_SIGNIN_DEV_URL,
  CARD_SERVICING_PATHS,
} from '../constants';

import { ifFeatureFlagOn } from './feature-flags';
import { getJWTFromLocalStorage } from './jwt';

// For funnel pages, including the Apply page and 404 page
export const prefixRoute = (route: string) => {
  const base = '/credit-card/apply';
  const prefixedRoute = `${base}${route}`;
  return prefixedRoute;
};

// Reserved for outside-of-funnel pages
export const prefixBaseRoute = (route: string) => {
  const base = '/credit-card';
  const prefixedRoute = `${base}${route}`;
  return prefixedRoute;
};

export const goToDashaboard = () => {
  const isCardStarRedirectOn = ifFeatureFlagOn(
    CARDSTAR_OVERRIDE_ACCOUNT_CREATION
  );
  if (!isCardStarRedirectOn) {
    return window.location.hostname === 'www.prosper.com'
      ? FISERV_SIGNIN_PROD_URL
      : FISERV_SIGNIN_DEV_URL;
  }
  if (!getJWTFromLocalStorage()) {
    const redirectUri = CARD_SERVICING_PATHS.dashboard + window.location.search;
    return `/auth/signout?redirect_uri=${encodeURIComponent(redirectUri)}`;
  }
  return CARD_SERVICING_PATHS.dashboard + window.location.search;
};
